import DownArrow from '@/assets/icons/down-arrow.svg?react';
import UpperArrow from '@/assets/icons/upper-arrow.svg?react';
import { ScrollArea } from '@/components/ui/scroll-area';
import { Skeleton } from '@/components/ui/skeleton';

const LadderLoader = () => {
  return (
    <div className="fixed inset-x-0 bottom-0 top-2 w-full bg-accent flex flex-col">
      <div className="relative h-26 w-full shadow-xs bg-white z-10 pt-16  flex justify-center">
        <div className="flex justify-between w-(--rail-track-width)">
          <UpperArrow className="w-8 h-8 text-muted-foreground/30 -translate-x-3" />
          <DownArrow className="w-8 h-8 text-muted-foreground/30 translate-x-3" />
        </div>
      </div>

      <div className="absolute inset-0 pointer-events-none flex justify-center">
        <div className="flex justify-between h-full w-(--rail-track-width)">
          <div className="w-2.5 h-full bg-muted-foreground/10" />
          <div className="w-2.5 h-full bg-muted-foreground/10" />
        </div>
      </div>

      <ScrollArea className="overflow-y-auto h-[calc(100dvh-225px)]">
        <div className="relative top-8 w-full flex flex-col items-center">
          <div className="w-full flex flex-col items-center gap-8 pb-10">
            {[...Array(10)].map((_, index) => (
              // eslint-disable-next-line react/no-array-index-key
              <div key={index} className="h-10 w-full flex items-center justify-center">
                <div className="h-10 bg-white rounded-lg flex items-center justify-center w-(--station-width)">
                  <Skeleton className="w-32 h-3 rounded-lg bg-accent" />
                </div>
              </div>
            ))}
          </div>
        </div>
      </ScrollArea>

      <div className="fixed bottom-13 w-full h-15 flex pr-31 justify-end items-center px-2.5 bg-white border-t border-t-transparent shadow-xs">
        <Skeleton className="w-35 h-9 rounded-md bg-gray-200" />
      </div>
    </div>
  );
};

export default LadderLoader;
